import {
    TRANSATION_LIST,
    TRANSATION_ADD,
    UPDATE_TRANSATION,
    TRANSATION_DELETE,
    LOADING,
    NOT_FOUND,
    TRANSATION_DETAIL,
    SURGE_PRICE_DETAIL,
    SURGE_PRICE_LIST,
  } from "../action/type";
  import { APIURL } from "./config";
  import { toast } from "react-toastify";
  import axios from "axios";
  
  export const getAllTransation = () => async (dispatch) => {
    dispatch({
      type: LOADING,
      payload: "",
    });
    const token = localStorage.getItem("token");
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const res = await axios.get(`${APIURL}/api/v1/transationCharges`, config);
      dispatch({
        type: TRANSATION_LIST,
        payload: res.data?.data?.TransationCh,
      });
      if (res.data?.data?.TransationCh?.length === 0) {
        dispatch({
          type: NOT_FOUND,
          payload: "",
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  export const getTransation = (id) => async (dispatch) => {
    dispatch({
      type: LOADING,
      payload: "",
    });
    const token = localStorage.getItem("token");
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const res = await axios.get(`${APIURL}/api/v1/transationCharges/${id}`, config);
      dispatch({
        type: TRANSATION_DETAIL,
        payload: res.data,
      });
      if (res.data?.data?.TransationCharges?.length === 0) {
        dispatch({
          type: NOT_FOUND,
          payload: "",
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  export const updateTransationCharges = (val, id) => async (dispatch) => {
    const token = localStorage.getItem("token");
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
  
    var body = JSON.stringify({
      charges: val.transaction,
    });
  
    try {
      const res = await axios.patch(
        `${APIURL}/api/v1/transationCharges/${id}`,
        body,
        config
      );
      dispatch({ type: UPDATE_TRANSATION, payload: res.data });
      toast.success("Transation charges updated successfully!");
      setTimeout(() => {
        return (window.reload());
      }, 1000);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  export const addTransation = (val) => async (dispatch) => {
    console.log(val,'val')
    const token = localStorage.getItem("token");
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
  
    var body = JSON.stringify({
      charges: val.transaction,
    });
    try {
      const res = await axios.post(`${APIURL}/api/v1/transationCharges`, body, config);
      console.log(res, 'res')
      dispatch({ type: TRANSATION_ADD, payload: res.data });
      toast.success("Transation charges added successfully!");
      setTimeout(() => {
        return (window.reload());
      }, 1000);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  export const getAllSurgePricing = () => async (dispatch) => {
    dispatch({
      type: LOADING,
      payload: "",
    });
    const token = localStorage.getItem("token");
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const res = await axios.get(`${APIURL}/api/v1/surgePricing`, config);
      dispatch({
        type: SURGE_PRICE_LIST,
        payload: res.data?.data?.SurgePrice,
      });
      if (res.data?.data?.SurgePrice?.length === 0) {
        dispatch({
          type: NOT_FOUND,
          payload: "",
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  export const getSurgePricing = (id) => async (dispatch) => {
    dispatch({
      type: LOADING,
      payload: "",
    });
    const token = localStorage.getItem("token");
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const res = await axios.get(`${APIURL}/api/v1/surgePricing/${id}`, config);
      dispatch({
        type: SURGE_PRICE_DETAIL,
        payload: res.data,
      });
      if (res.data?.data?.SurgePrice?.length === 0) {
        dispatch({
          type: NOT_FOUND,
          payload: "",
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  export const addSurgePricing = (val) => async (dispatch) => {
    const token = localStorage.getItem("token");
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
  
    var body = JSON.stringify({
        price: val.surge,
        startTime: val.startTime,
        endTime: val.endTime,
    });
    try {
      const res = await axios.post(`${APIURL}/api/v1/surgePricing`, body, config);
      dispatch({ type: TRANSATION_ADD, payload: res.data });
      toast.success("Surge pricing added successfully!");
      setTimeout(() => {
        // return (window.location.href = "/all-rentals");
      }, 1000);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };
  
  export const updateSurgePricing = (val, id) => async (dispatch) => {
    const token = localStorage.getItem("token");
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
  
    var body = JSON.stringify({
      price: val.surge,
        startTime: val.startTime,
        endTime: val.endTime,
    });
  
    try {
      const res = await axios.patch(
        `${APIURL}/api/v1/surgePricing/${id}`,
        body,
        config
      );
      dispatch({ type: UPDATE_TRANSATION, payload: res.data });
      toast.success("Surge pricing updated successfully!");
      setTimeout(() => {
        // return (window.location.href = "/all-rentals");
      }, 1000);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };
  
  